import { selectLastRegistrationPoseUsed } from "@/registration-tools/common/store/registration-selectors";
import { useAppSelector } from "@/store/store-hooks";
import { FaroButton } from "@faro-lotv/flat-ui";
import Stack from "@mui/material/Stack";
import { type JSX } from "react";
import {
  AlignmentBarInfoProps,
  PairwiseRegistrationBarInfo,
} from "./pairwise-registration-bar-info";

/** Info about current alignment and callbacks for events */
type PairwiseRegistrationBarProps = AlignmentBarInfoProps & {
  /** The user confirmed the workflow */
  onConfirmClick(): void;
};

/**
 * @returns Utility bar that provides buttons for registration refinement and confirming the result
 */
export function PairwiseRegistrationBar({
  areaName,
  pointCloudNames,
  pointCloudLabels,
  onConfirmClick,
}: PairwiseRegistrationBarProps): JSX.Element {
  const lastRegistrationPoseUsed = useAppSelector(
    selectLastRegistrationPoseUsed,
  );

  return (
    <Stack
      direction="row"
      sx={{
        alignItems: "center",
        justifyContent: "space-between",
        py: 1,
        px: 4,
        backgroundColor: "gray100",
      }}
    >
      <PairwiseRegistrationBarInfo
        areaName={areaName}
        pointCloudNames={pointCloudNames}
        pointCloudLabels={pointCloudLabels}
      />
      <FaroButton
        onClick={onConfirmClick}
        variant={lastRegistrationPoseUsed ? "primary" : "secondary"}
      >
        Save & exit
      </FaroButton>
    </Stack>
  );
}
